<template>
  <div>
    <template v-if="items">
      <template v-for="(item, index) in items">
        <slot v-bind="{ item, index, size, total, pageNumber }"></slot>
      </template>
      <div class="text-xs-center">
        <v-pagination :length="pageCount" v-model="pageNumber"></v-pagination>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  props: ['value'],
  data() {
    return {
      total: 0,
      pageNumber: 1,
      size: 10, // Size per page
      items: []
    }
  },
  computed: {
    pageCount() {
      let l = this.total
      let s = this.size
      return Math.ceil(l / s)
    }
  },
  mounted() {
    this.setupItems(this.value)
  },
  methods: {
    setupItems(val) {
      this.pageNumber = 1

      // eslint-disable-next-line no-undef
      let items = _.cloneDeep(val)
      if (!items) {
        this.total = 0
        return []
      }
      this.total = items.length
      this.changePage(items, this.pageNumber)
    },
    changePage(items, pageNumber) {
      const start = (pageNumber - 1) * this.size
      const end = start + this.size
      this.items = items.slice(start, end)
    }
  },
  watch: {
    pageNumber(newVal, oldVal) {
      if (newVal != oldVal) this.changePage(this.value, newVal)
    },
    value(newVal, oldVal) {
      if (newVal != oldVal) {
        this.setupItems(newVal)
        if (this.pageCount <= 1) this.pageNumber = 1
        else if (this.pageCount < this.pageNumber)
          this.pageNumber = this.pageCount
      }
    }
  }
}
</script>

<style lang="scss" scoped></style>
